import { render, staticRenderFns } from "./cUser.vue?vue&type=template&id=51f1668c&scoped=true&"
import script from "./cUser.vue?vue&type=script&lang=js&"
export * from "./cUser.vue?vue&type=script&lang=js&"
import style0 from "./cUser.vue?vue&type=style&index=0&id=51f1668c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1668c",
  null
  
)

export default component.exports